import { render, staticRenderFns } from "./StaffList.vue?vue&type=template&id=17ab8e59&scoped=true&lang=pug&"
import script from "./StaffList.vue?vue&type=script&lang=ts&"
export * from "./StaffList.vue?vue&type=script&lang=ts&"
import style0 from "./StaffList.vue?vue&type=style&index=0&id=17ab8e59&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ab8e59",
  null
  
)

export default component.exports